module.exports = __webpack_public_path__ + "img/caas4-m@2.56547f37.webp";